import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import { Box, Typography, Paper, Button, CircularProgress } from '@mui/material';
import axios from 'axios';

const UserDebug = () => {
  const { user, isAuthenticated, loading } = useContext(AuthContext);
  const [userData, setUserData] = useState(null);
  const [error, setError] = useState(null);
  const [fetchLoading, setFetchLoading] = useState(false);

  const fetchUserData = async () => {
    setFetchLoading(true);
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setError('No token found');
        return;
      }

      const response = await axios.get(`${process.env.REACT_APP_API_URL}/auth/user`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      setUserData(response.data);
      console.log('User data from API:', response.data);
    } catch (err) {
      console.error('Error fetching user data:', err);
      setError(err.response?.data?.message || 'Failed to fetch user data');
    } finally {
      setFetchLoading(false);
    }
  };

  return (
    <Box sx={{ p: 4, maxWidth: 800, mx: 'auto', mt: 4 }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>User Debug Information</Typography>
        
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6">Authentication Status:</Typography>
          <Typography>
            {loading ? 'Loading...' : isAuthenticated ? 'Authenticated' : 'Not Authenticated'}
          </Typography>
        </Box>
        
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6">User from Context:</Typography>
          <Paper sx={{ p: 2, bgcolor: '#f5f5f5', overflowX: 'auto' }}>
            <pre>{user ? JSON.stringify(user, null, 2) : 'No user data'}</pre>
          </Paper>
        </Box>
        
        <Box sx={{ mb: 3 }}>
          <Typography variant="h6">Token from localStorage:</Typography>
          <Paper sx={{ p: 2, bgcolor: '#f5f5f5', overflowX: 'auto', wordBreak: 'break-all' }}>
            {localStorage.getItem('token') || 'No token found'}
          </Paper>
        </Box>
        
        <Button 
          variant="contained" 
          onClick={fetchUserData}
          disabled={fetchLoading}
          sx={{ mb: 3 }}
        >
          {fetchLoading ? <CircularProgress size={24} sx={{ mr: 1 }} /> : null}
          Fetch User Data from API
        </Button>
        
        {error && (
          <Box sx={{ mb: 3, color: 'error.main' }}>
            <Typography variant="h6">Error:</Typography>
            <Typography>{error}</Typography>
          </Box>
        )}
        
        {userData && (
          <Box sx={{ mb: 3 }}>
            <Typography variant="h6">User Data from API:</Typography>
            <Paper sx={{ p: 2, bgcolor: '#f5f5f5', overflowX: 'auto' }}>
              <pre>{JSON.stringify(userData, null, 2)}</pre>
            </Paper>
          </Box>
        )}
        
        <Typography variant="h6" gutterBottom>Fix Instructions:</Typography>
        <ol>
          <li>Check the structure of the user data from both Context and API</li>
          <li>Verify that the role property exists and has the correct value</li>
          <li>Update the Home component to handle the correct user data structure</li>
          <li>Update the AuthContext if needed to store the user data correctly</li>
        </ol>
      </Paper>
    </Box>
  );
};

export default UserDebug;
